 let options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    timeZoneName: "short",
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: "Etc/Greenwich",
    hour12: false
};

 const formatter = new Intl.DateTimeFormat("en-GB", options as Intl.DateTimeFormatOptions)
 
 function formatDateToIfModifiedFormat(date: Date) {
  
  const dateParts = formatter.formatToParts(date);

  const dateMap = Object.fromEntries(dateParts.map(part => [part.type, part]));

  return `${dateMap.weekday.value}, ${dateMap.day.value} ${dateMap.month.value} ${dateMap.year.value} ${dateMap.hour.value}:${dateMap.minute.value}:${dateMap.second.value} GMT`;
}

interface StartPollerConfigOptions {
    request:  (ifModifiedSince: string) => Promise<any>
    onSuccess?: (...args: any) => void,
    onError?: (...args: any) => void,
    config?: {
        timeout?: number,
        stopPollingOnError?: boolean
    }
    
}
 
 
class HttpPollingService {
    private lastModified: string = '';
    private isPolling: boolean = false;

    updateLastModified(date: Date) {
        this.lastModified =  formatDateToIfModifiedFormat(date);
    }

    startPoller({request, onSuccess, onError, config} : StartPollerConfigOptions){
        if (this.isPolling) {
            this.endPoller(); // stop previous polling loop
        }

        this.isPolling = true;
        const timeout = config?.timeout ?? 5000; // default: 5s

        const poll = () => {
            let stopOnError = false;
        
            if (!this.isPolling) return;

            request(this.lastModified)
            .then(({ data }) => {
                if (data) {
                    onSuccess?.(data);
                    this.lastModified = formatDateToIfModifiedFormat(new Date());
                }
            })
            .catch((err) => {
                onError?.(err);
                
                if (config?.stopPollingOnError) {
                    stopOnError = true;
                    this.endPoller();
                    return;
                }
            })
            .finally(() => {
                if (this.isPolling && !stopOnError) {
                    setTimeout(poll, timeout);
                }
            });
        };

        poll();
    };

    endPoller(){
        this.isPolling = false;
    }
 }

 export default HttpPollingService;
 